/**
 * Shared constants for the inspire-events package
 */

// Timezone mappings from display names to IANA identifiers
export const TIMEZONE_MAP: Record<string, string> = {
  "Eastern Time (US & Canada)": "America/New_York",
  "Central Time (US & Canada)": "America/Chicago",
  "Mountain Time (US & Canada)": "America/Denver",
  "Pacific Time (US & Canada)": "America/Los_Angeles",
  Alaska: "America/Anchorage",
  Hawaii: "Pacific/Honolulu",
};

// Timezone options for Select components
export const TIMEZONE_OPTIONS = [
  { value: "Eastern Time (US & Canada)", label: "Eastern Time (US & Canada)" },
  { value: "Central Time (US & Canada)", label: "Central Time (US & Canada)" },
  { value: "Mountain Time (US & Canada)", label: "Mountain Time (US & Canada)" },
  { value: "Pacific Time (US & Canada)", label: "Pacific Time (US & Canada)" },
  { value: "Alaska", label: "Alaska" },
  { value: "Hawaii", label: "Hawaii" },
];

// Pagination
export const STORY_PAGE_SIZE = 12;
export const THEME_PAGE_SIZE = 5;
export const STATIC_PAGE_LIMIT = 300;

// Form limits
export const MAX_TEXT_AREA_LENGTH = 200;
export const MAX_STORY_LENGTH = 6000;
export const DONATION_STEPS = 3;

// Colors
export const COLORS = {
  SUCCESS_GREEN: "#359960",
  SUCCESS_GREEN_DARK: "#36905b",
  INFO_BLUE: "#4a6097",
  BORDER_GRAY: "#D9D9D9",
  CARD_BORDER: "#e8e8e8",
  ERROR_RED: "#bc362e",
} as const;

// Banner styles (reusable across components)
export const SUCCESS_BANNER_STYLE = {
  backgroundColor: COLORS.SUCCESS_GREEN,
  borderTop: `1px solid ${COLORS.SUCCESS_GREEN}`,
  borderLeft: `1px solid ${COLORS.SUCCESS_GREEN}`,
  borderRight: `1px solid ${COLORS.SUCCESS_GREEN}`,
  borderBottom: `2px solid ${COLORS.SUCCESS_GREEN}`,
} as const;

export const INFO_BANNER_STYLE = {
  backgroundColor: "#f9f9fd",
  backgroundImage: "radial-gradient(#e9eff7 20%, transparent 40%)",
  backgroundSize: "7px 7px",
  backgroundRepeat: "repeat",
  borderTop: `1px solid ${COLORS.BORDER_GRAY}`,
  borderLeft: `1px solid ${COLORS.BORDER_GRAY}`,
  borderRight: `1px solid ${COLORS.BORDER_GRAY}`,
  borderBottom: `2px solid ${COLORS.BORDER_GRAY}`,
} as const;

// Default donation amounts
export const DEFAULT_DONATION_AMOUNTS = [10, 25, 50, 100];

// Privacy/visibility status values
export const VISIBILITY_STATUS = {
  PUBLIC: 0,
  PRIVATE: 2,
} as const;

// Thank you notes defaults
export const THANK_YOU_NOTES_BUTTON_TITLE_DEFAULT = "SEND THANK YOU NOTES";
export const THANK_YOU_NOTES_TITLE_DEFAULT =
  "Show how much you appreciate your friends who made this project a success!";
